<script setup>
const resources = [
  {
    title: 'Public Resources Hub',
    description:
      'Single landing page with direct links to every public onboarding and review document.',
    href: '/resources.html',
    label: 'Open resources hub',
  },
  {
    title: 'Meta App Review Permissions',
    description:
      'Permission descriptions for Facebook, Instagram, and WhatsApp review.',
    href: '/meta-app-review.html',
    label: 'Open review page',
  },
  {
    title: 'Client Onboarding Email Template',
    description:
      'Welcome email and channel setup follow-up for new client accounts.',
    href: '/client-onboarding-email.html',
    label: 'Open email template',
  },
  {
    title: 'WhatsApp Message Scripts',
    description:
      'Short onboarding, follow-up, and reminder messages for WhatsApp.',
    href: '/whatsapp-onboarding-messages.html',
    label: 'Open WhatsApp scripts',
  },
  {
    title: 'Client Tracking Spreadsheet',
    description:
      'Manual sheet structure for clients, payments, revenue, and setup tracking.',
    href: '/client-tracking-spreadsheet.html',
    label: 'Open spreadsheet guide',
  },
];
</script>

<template>
  <div class="flex flex-col gap-6 h-full min-h-0 overflow-auto p-6 lg:p-8 bg-n-surface-1">
    <section class="rounded-2xl border border-n-slate-6 bg-white p-6 shadow-sm">
      <p class="text-xs font-semibold uppercase tracking-[0.2em] text-n-brand-11">
        NamsFlow Toolkit
      </p>
      <h1 class="mt-2 text-2xl font-semibold text-n-slate-12">
        Client onboarding and Meta review resources
      </h1>
      <p class="mt-2 max-w-3xl text-sm leading-6 text-n-slate-10">
        Use this page as the single place to open the public review documents and the onboarding templates that support your Phase 1 client setup workflow.
      </p>
    </section>

    <section class="grid gap-4 xl:grid-cols-2">
      <article
        v-for="(resource, index) in resources"
        :key="resource.title"
        class="rounded-2xl border border-n-slate-6 bg-white p-6 shadow-sm"
      >
        <div class="flex items-start justify-between gap-4">
          <div>
            <p class="text-xs font-semibold uppercase tracking-[0.2em] text-n-slate-9">
              Step {{ index + 1 }}
            </p>
            <h2 class="mt-2 text-lg font-semibold text-n-slate-12">
              {{ resource.title }}
            </h2>
          </div>
          <span class="rounded-full bg-n-brand-2 px-3 py-1 text-xs font-semibold text-n-brand-11">
            Ready
          </span>
        </div>

        <p class="mt-3 text-sm leading-6 text-n-slate-10">
          {{ resource.description }}
        </p>

        <a
          :href="resource.href"
          target="_blank"
          rel="noopener noreferrer"
          class="mt-5 inline-flex items-center justify-center rounded-xl bg-n-brand-10 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-n-brand-11"
        >
          {{ resource.label }}
        </a>
      </article>
    </section>

    <section class="rounded-2xl border border-n-slate-6 bg-white p-6 shadow-sm">
      <h2 class="text-lg font-semibold text-n-slate-12">Suggested workflow</h2>
      <ol class="mt-3 list-decimal space-y-2 pl-5 text-sm leading-6 text-n-slate-10">
        <li>Share the Meta App Review page when you need platform permission descriptions.</li>
        <li>Send the welcome email template as soon as the client account is created.</li>
        <li>Use the WhatsApp scripts for payment confirmation, login details, and follow-ups.</li>
        <li>Use the spreadsheet guide to track clients and payments until billing is automated.</li>
      </ol>
    </section>
  </div>
</template>
